import type { ReactNode } from "react";
import type { ViewStyle } from "react-native";
import { TabScreen, Tabs, TabsProvider } from "react-native-paper-tabs";
import { useAppTheme } from "../useAppTheme";

interface TabData {
	label: string;
	content: ReactNode;
	badge?: string | number | boolean;
	icon?: string;
}

interface Props {
	tabs: TabData[];
	mode?: "scrollable" | "fixed";
	defaultIndex?: number;
	onChangeIndex?: (index: number) => void;
	backgroundColor?: string;
	iconPosition?: "leading" | "top";
	uppercase?: boolean;
	/** Styles the full-width band behind the tab row. */
	tabHeaderStyle?: ViewStyle;
	/** Styles the tab row itself, e.g. to constrain it to a content column. */
	tabBarStyle?: ViewStyle;
}

const CustomTabs = ({
	tabs,
	mode = "fixed",
	defaultIndex,
	onChangeIndex,
	backgroundColor,
	iconPosition,
	uppercase,
	tabHeaderStyle,
	tabBarStyle,
}: Props) => {
	const theme = useAppTheme();

	return (
		<TabsProvider defaultIndex={defaultIndex} onChangeIndex={onChangeIndex}>
			<Tabs
				style={{
					backgroundColor: backgroundColor ?? theme.colors.elevation.level3,
					...tabBarStyle,
				}}
				mode={mode}
				iconPosition={iconPosition}
				uppercase={uppercase}
				tabHeaderStyle={tabHeaderStyle}
				theme={{
					colors: {
						primary: theme.colors.primary,
					},
				}}
			>
				{tabs.map((item) => (
					<TabScreen
						badge={item.badge}
						key={item.label}
						label={item.label}
						icon={item.icon}
					>
						{item.content}
					</TabScreen>
				))}
			</Tabs>
		</TabsProvider>
	);
};

export default CustomTabs;
